import datePicker from './datePicker';
import hidden from './hidden';
import input from './input';
import slider from './slider';
import timePicker from './timePicker';
import row from './row';
import select from './select';

export default [
    datePicker,
    hidden,
    input,
    slider,
    timePicker,
    row,
    select
]
